import React from 'react';
import { Card } from './ui/card';
import { Search, FileText, AlertCircle, Shield } from 'lucide-react';
import { servicesData } from '../data/mock';

const iconMap = {
  0: Search,
  1: FileText,
  2: AlertCircle,
  3: Shield
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4">
              {servicesData.title}
            </h2>
            <div className="w-24 h-1 bg-[#2d8b8b] mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {servicesData.subtitle}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {servicesData.services.map((service, index) => {
              const Icon = iconMap[index];
              return (
                <Card key={index} className="p-8 hover:shadow-xl transition-all duration-300 border-t-4 border-[#2d8b8b]">
                  <div className="mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-lg flex items-center justify-center mb-4">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-[#1e3a5f] mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-6">
                      {service.description}
                    </p>
                  </div>

                  <div className="grid sm:grid-cols-2 gap-3">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <div className="w-1.5 h-1.5 bg-[#2d8b8b] rounded-full flex-shrink-0 mt-2"></div>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
